
export const LINKS = {
  SHOP: "https://www.raizamagarden.com.br/",
  WEB: "https://linktr.ee/raizama.garden",
};

export const APP_INFO = {
  NAME: "Raizama Garden CARE",
  SLOGAN: "Para ajudar você a catalogar e cuidar da sua coleção de plantas",
  LOGO_URL: "https://dvncpslpjsggfknqxuga.supabase.co/storage/v1/object/public/Arquivos/LOGO.png",
  VERSION: "1.2.8"
};

export const MOCK_IMAGES = {
  PROFILE: "https://picsum.photos/200/200",
  PLANT_PLACEHOLDER: "https://picsum.photos/400/400",
};